export default __webpack_public_path__ + "static/media/c245b3e704bfbc9d157aae4ceedd381b.d064f140.png";